import { render, staticRenderFns } from "./TeacherRequests.vue?vue&type=template&id=78c2b412&scoped=true"
import script from "./TeacherRequests.vue?vue&type=script&lang=js"
export * from "./TeacherRequests.vue?vue&type=script&lang=js"
import style0 from "./TeacherRequests.vue?vue&type=style&index=0&id=78c2b412&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78c2b412",
  null
  
)

export default component.exports